import React, { useState } from 'react'
import '../createpassword/CreatePassword.css'
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import useApi from '../../customHook/useApi';

const CreatePassword = () => {
    const navigate = useNavigate(); // for navigation
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const { data, error, loading, postFormData } = useApi('https://codezens.com/luststory/index.php/api');

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate the passwords
        if (!password || !confirmPassword) {
            toast.error('Both fields are required!');
            return;
        }

        if (password !== confirmPassword) {
            toast.error('Passwords do not match!');
            return;
        }

        if (password.length < 6) {
            toast.error('Password must be at least 6 characters!');
            return;
        }

        // If validation is successful, make the API call
        try {
            const response = await postFormData('/create_password', {
                user_id: 28, // Replace with dynamic user ID if needed
                password,
            });

            if (response && response.status === 1) {
                // Handle successful password creation (e.g., redirect, show success message, etc.)
                // console.log('Password created successfully');
                navigate('/signup-category')
            } else {
                toast.error(response.message || 'An error occurred');
            }
        } catch (error) {
            toast.error('Failed to create password!');
        }
    };
    return (

        <div className='create-pw-section w-100 position-relative'>
            <Link rel='stylesheet' to="/signup" className='back-btn'>Back</Link>
            <div className='create-pw-code-box d-flex flex-wrap align-content-center justify-content-center'>
                <h6 className='text-center'>Create Password</h6>
                <div className='create-pw-code-form w-100'>
                    <form action="" className='d-flex align-items-center justify-content-between'>
                        <div class="input-box">
                            <input type="text" className="form-control text-left" onChange={(e) => setPassword(e.target.value)} placeholder="Enter Password" />
                        </div>
                        <div class="input-box">
                            <input type="text" className="form-control text-left" onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Confirm Password" />
                        </div>
                    </form>
                    {/* <p className='text-left mt-4'><Link rel='stylesheet' to="/persona-verification">Confirm Password</Link></p> */}
                    <p className='text-center mt-4 cursor-pointer' onClick={handleSubmit}>Next</p>
                </div>
            </div>
        </div>
    )
}

export default CreatePassword
